import { Badge, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { MdWarning } from 'react-icons/md';

import { JournalEntryCard } from '../JournalEntryCard/JournalEntryCard';
import { SymptomJournalEntry } from '../types';

export interface SymptomEntryCardProps {
  entry: SymptomJournalEntry;
}

/**
 * Displays a symptom journal entry with symptom names and comments.
 */
export const SymptomEntryCard: React.FC<SymptomEntryCardProps> = ({
  entry,
}) => {
  // Prefer symptomNames over legacy symptoms field
  const symptoms =
    entry.symptomNames.length > 0 ? entry.symptomNames : entry.symptoms;

  return (
    <JournalEntryCard
      entryId={entry.id}
      icon={<Icon as={MdWarning} color="status.error" boxSize={5} />}
      title={
        <Text fontSize="sm" fontWeight={600} color="text.default">
          Symptoms
        </Text>
      }
      time={entry.createdAt}
      timezone={entry.timezone}
      comments={entry.comments}
    >
      {({ isExpanded: expanded }) => (
        <VStack align="stretch" spacing={2}>
          <HStack spacing={1} flexWrap="wrap">
            {symptoms.map((symptom, idx) => (
              <Badge key={idx} fontSize="xs" colorScheme="red">
                {symptom}
              </Badge>
            ))}
          </HStack>

          {/* Description */}
          {expanded && entry.description && (
            <Text fontSize="sm" color="text.default">
              {entry.description}
            </Text>
          )}
        </VStack>
      )}
    </JournalEntryCard>
  );
};

SymptomEntryCard.displayName = 'SymptomEntryCard';
